import { SET_WORKING_TIME_AGREEMENT, RESET_REPORT, SET_REPORT, SET_REPORTS, SET_EXTERNAL_REPORTS } from "./types";
import backend, { recursiveRequest } from "../apis/backend";
import errorHandler from "../helpers/errorHandler";
import store from "../store";

export const checkAgreement = () => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/working-time/check`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_WORKING_TIME_AGREEMENT, payload: response.data });
    }
    catch (error) { errorHandler(error, null); }
};

export const resetReport = () => (dispatch) => dispatch({ type: RESET_REPORT });

export const getReport = (userID, type) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/working-time/${userID !== null && userID !== undefined ? userID : store.getState().user.current.userID}?month=${type}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_REPORT, payload: response.data.report });
    }
    catch (error) { errorHandler(error, null); }
}

export const getReports = type => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/working-time?month=${type}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_REPORTS, payload: response.data.reports });
    }
    catch (error) { errorHandler(error, null); }
}

export const getExternalReports = type => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/working-time/external?month=${type}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_EXTERNAL_REPORTS, payload: response.data.reports });
    }
    catch (error) { errorHandler(error, null); }
}

export const agree = () => async (dispatch) => {
    try {        
        const response = await recursiveRequest(async () => {
            return await backend.post(`/api/working-time`, {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_WORKING_TIME_AGREEMENT, payload: { agreement: true } });
    }
    catch (error) { errorHandler(error, null); }
};

export const disagree = () => async (dispatch) => {
    try {        
        const response = await recursiveRequest(async () => {
            return await backend.delete(`/api/working-time`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_WORKING_TIME_AGREEMENT, payload: { agreement: false } });
    }
    catch (error) { errorHandler(error, null); }
};